/*
  Cursor do UO: a manopla (src/styles/cursor.css, gerado por tools/cursor/gerar-cursor.py).

  Este módulo só decide o estado e escreve no <html>:
    data-cursor  = normal | clique | arraste | mira
    data-combate = presente quando o personagem está em combate (War ligado ou caçada lutando)

  Prioridade: arraste > mira > clique > normal. O clique fica pelo menos CLIQUE_MS na tela,
  senão um clique rápido nem mostra o movimento da pinça.
*/

type Estado = 'normal' | 'clique' | 'arraste' | 'mira';

const CLIQUE_MS = 140;
/** Entre um mob e outro a caçada fica sem alvo por um instante; sem isto o cursor pisca. */
const SAIR_DO_COMBATE_MS = 1500;

const ARQUIVOS = [
  'normal', 'clique', 'arraste', 'mira',
  'combate-normal', 'combate-clique', 'combate-arraste', 'combate-mira'
];

let instalado = false;
let combate = false;
let apertado = false;
let apertouEm = 0;
let soltar = 0;
let saida = 0;
const arrastes = new Set<string>();
const miras = new Set<string>();

function aplicar() {
  if (!instalado) return;
  const raiz = document.documentElement;
  const estado: Estado = arrastes.size > 0 ? 'arraste' : miras.size > 0 ? 'mira' : apertado ? 'clique' : 'normal';
  if (raiz.dataset.cursor !== estado) raiz.dataset.cursor = estado;
  if (combate) {
    if (!raiz.hasAttribute('data-combate')) raiz.setAttribute('data-combate', '');
  } else if (raiz.hasAttribute('data-combate')) {
    raiz.removeAttribute('data-combate');
  }
}

function apertar(e: PointerEvent) {
  if (e.button !== 0 || e.pointerType === 'touch') return;
  window.clearTimeout(soltar);
  apertado = true;
  apertouEm = performance.now();
  aplicar();
}

function largar() {
  // Rede de segurança: todo arraste acaba no soltar do botão. Se alguém desmontou no meio
  // e não avisou, a manopla fechada não fica presa.
  if (arrastes.size > 0) window.setTimeout(() => { if (arrastes.size > 0) { arrastes.clear(); aplicar(); } }, 50);
  if (!apertado) return;
  const falta = Math.max(0, CLIQUE_MS - (performance.now() - apertouEm));
  window.clearTimeout(soltar);
  soltar = window.setTimeout(() => {
    apertado = false;
    aplicar();
  }, falta);
}

/** Liga a manopla no documento inteiro. Uma vez, no começo do app. */
export function instalarCursor(): void {
  if (instalado || typeof window === 'undefined') return;
  instalado = true;
  // Baixa as oito antes de precisar: trocar de estado não pode piscar a seta do sistema.
  for (const nome of ARQUIVOS) {
    const img = new Image();
    img.src = `/cursor/${nome}.png`;
  }
  window.addEventListener('pointerdown', apertar, true);
  window.addEventListener('pointerup', largar, true);
  window.addEventListener('pointercancel', largar, true);
  window.addEventListener('blur', () => {
    apertado = false;
    miras.clear();
    arrastes.clear();
    aplicar();
  });
  aplicar();
}

/** War ligado ou caçada lutando. Sair do combate espera um pouco (ver SAIR_DO_COMBATE_MS). */
export function cursorCombate(ligado: boolean): void {
  // O motor chama a cada quadro do servidor: o prazo de saída não pode ser renovado sempre.
  if (ligado) {
    window.clearTimeout(saida);
    saida = 0;
    if (!combate) {
      combate = true;
      aplicar();
    }
    return;
  }
  if (!combate || saida) return;
  saida = window.setTimeout(() => {
    saida = 0;
    combate = false;
    aplicar();
  }, SAIR_DO_COMBATE_MS);
}

/** Sai do combate na hora (troca de personagem, saída do mundo). */
export function cursorForaDeCombate(): void {
  window.clearTimeout(saida);
  saida = 0;
  combate = false;
  aplicar();
}

/** Mira sobre jogador ou loot. `fonte` separa quem pediu (o mundo, um gump…). */
export function cursorMira(fonte: string, ligado: boolean): void {
  const tinha = miras.has(fonte);
  if (ligado === tinha) return;
  if (ligado) miras.add(fonte);
  else miras.delete(fonte);
  aplicar();
}

/** Começou (true) ou acabou (false) um arraste: skill na barra, item, janela. */
export function cursorArraste(fonte: string, ligado: boolean): void {
  const tinha = arrastes.has(fonte);
  if (ligado === tinha) return;
  if (ligado) arrastes.add(fonte);
  else arrastes.delete(fonte);
  aplicar();
}
